import React from "react"

import classNames from "classnames"

import { times } from "shared/lib/times"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

interface BoxSelectLoaderProps
  extends React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>> {
  optionClassName?: string
}

export const BoxSelectLoader = React.memo(
  ({ optionClassName, className, ...props }: BoxSelectLoaderProps) => {
    return (
      <div {...props} className={classNames("box-select", className)}>
        {times(4).map(index => (
          <Skeleton
            key={index}
            containerClassName={classNames(
              "box-select-button loading",
              optionClassName
            )}
          />
        ))}
      </div>
    )
  }
)
